export default "__VITE_ASSET__CVhEtq39__"